import { render } from "./attachmodel.vue?vue&type=template&id=cd0d5588&scoped=true"
import script from "./attachmodel.vue?vue&type=script&lang=js"
export * from "./attachmodel.vue?vue&type=script&lang=js"

import "./attachmodel.vue?vue&type=style&index=0&id=cd0d5588&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_13b2cfeee597e475bd48dd409a32edc8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd0d5588"]])

export default __exports__